import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Breadcrumb, Loader, Nav, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import AdvanceShareTemplateForm from './advance-share-template-form';
import AdvanceShareTemplateDesignList from './advance-share-template-design-list';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { AxiosError } from 'axios';
import { toastErrorMessage } from '@/utils/toasterMessage';
import { AdvanceShareTemplate } from '@/models/advance-share-template.model';
import { getAdvanceShareTemplate } from '@/services/advance-share-template.service';

const CustomNav = ({ active, onSelect, ...props }) => {
  return (
    <Nav {...props} activeKey={active} onSelect={onSelect}>
      <Nav.Item eventKey="template-form">Template Detail</Nav.Item>
      <Nav.Item eventKey="template-designs">Designs</Nav.Item>
    </Nav>
  );
};

const Page = () => {

  const [activeTab, setActiveTab] = useState('template-form');
  const [formObject, setFormObject] = useState<AdvanceShareTemplate | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();

  const { id: idParam } = useParams();
  const id = idParam ? parseInt(idParam, 10) : undefined;

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const fetchData = async () => {
    if (id) {
      setLoading(true);
      try {
        const result: BaseResponseModel<AdvanceShareTemplate> = await getAdvanceShareTemplate(id);
        if (result.success) {
          setFormObject(result.result);
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in fetching Template: ${errorModel?.errorMessage}`);
        nav('/advance-shares/templates');
      }
      finally {
        setLoading(false);
      }
    }
  };

  return (
    <Panel
      header={
        <PageHeader title={formObject ? `Template: ${formObject.name}` : 'Template'}>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >Advance Shares</Breadcrumb.Item>
            <Breadcrumb.Item href="/advance-shares/templates">Templates</Breadcrumb.Item>
            <Breadcrumb.Item active>Detail</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <CustomNav appearance="subtle" active={activeTab} onSelect={key => setActiveTab(key)} />
      {
        loading ? <Loader center content="loading ..." /> :
        <>
          {activeTab == 'template-form' && <AdvanceShareTemplateForm formObject={formObject} />}
          {activeTab == 'template-designs' && id && <AdvanceShareTemplateDesignList templateId={id} />}
        </>
      }
    </Panel>
  );
};

export default Page;
